import React, { ReactElement } from "react";
import "./styles.scss";

interface CardInfoProps {
  title: string;
  children: ReactElement;
  step: string;
}

function CardInfo({ title, children, step }: CardInfoProps) {
  return (
    <div className={`cardInfo step-${step}`}>
      <h3>{title}</h3>
      {children}
    </div>
  );
}

export { CardInfo };
